import "mutationobserver-shim";
import Vue from "vue";
import "./bootstrap-vue";
import { ModalPlugin } from "bootstrap-vue";
import App from "./App.vue";
import router from "./router";
import store from "./store/index";
import i18n from "./i18n";
import "@/assets/locales/dateFormats/kl";
import VueAppInsights from "vue-application-insights";
import { getApplicationSettingsInsights } from "@/services/applicationSettings/applicationSettingsService";
import { logError } from "@/services/logging/loggingService";
import vscCheckbox from "@/components/common/formComponents/vsc-checkbox.vue";
import vscInput from "@/components/common/formComponents/vsc-input.vue";
import vscSelect from "@/components/common/formComponents/vsc-select.vue";
import vscNameInput from "@/components/common/formComponents/vsc-name-input.vue";
import VueLodash from "vue-lodash";
import lodash from "lodash";

Vue.use(VueLodash, { name: "custom", lodash: lodash });

Vue.component("vsc-checkbox", vscCheckbox);
Vue.component("vsc-input", vscInput);
Vue.component("vsc-select", vscSelect);
Vue.component("vsc-name-input", vscNameInput);

Vue.config.productionTip = false;
Vue.use(ModalPlugin);

Vue.config.errorHandler = (error) => {
    logError(error.stack);
};

getApplicationSettingsInsights({ keys: ["AppInsightsConfigSPA"] }).then(settings => {
    const insightsConfig = settings ? JSON.parse(settings.appInsightsConfigSPA || "{}") : {};
    Vue.use(VueAppInsights, {
        baseName: "Vue SPA", // prefix to track route changes as page views with AppInsights
        appInsightsConfig: insightsConfig,
        router
    });

    Vue.directive("focus", {
        inserted: function (el) {
            el.focus();
        }
    });
    store.dispatch("authentication/validateToken");

    new Vue({
        store,
        router,
        i18n,
        render: h => h(App)
    }).$mount("#app");
});
